export default __webpack_public_path__ + "static/media/17.584cc451.png";